<template>
  <div class="health-quick-actions">
    <div class="row g-3 mb-4 justify-content-center">
      <div class="col-md-4 col-6">
        <div
          class="card border-0 shadow-sm h-100 action-card"
          @click="$emit('tab-change', 'menstrual')"
        >
          <div class="card-body text-center">
            <i class="bi bi-calendar-heart text-danger mb-2" style="font-size: 2rem"></i>
            <h6 class="card-title">Menstrual Tracking</h6>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-6">
        <div
          class="card border-0 shadow-sm h-100 action-card"
          @click="$emit('tab-change', 'health-data')"
        >
          <div class="card-body text-center">
            <i class="bi bi-activity text-success mb-2" style="font-size: 2rem"></i>
            <h6 class="card-title">Health Data</h6>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-6">
        <div
          class="card border-0 shadow-sm h-100 action-card"
          @click="$emit('tab-change', 'ai-analysis')"
        >
          <div class="card-body text-center">
            <i class="bi bi-robot text-info mb-2" style="font-size: 2rem"></i>
            <h6 class="card-title">AI Analysis</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthQuickActions',
  emits: ['tab-change'],
}
</script>

<style scoped>
.action-card {
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

.card-title {
  font-size: 0.9rem;
  margin: 0;
}

@media (max-width: 768px) {
  .card-body {
    padding: 1rem 0.5rem;
  }

  .card-title {
    font-size: 0.8rem;
  }
}
</style>
